<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Visitor</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <h6>Full Name</h6>
  <p>
    <a (click)="onUserPublicView(visitor.hash)"
       matTooltip="View User Public Profile">
      {{ visitor.contact_person }}
    </a>
  </p>

  <h6>Email Address</h6>
  <p>{{ visitor.email }}</p>


  <h6>{{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}</h6>
  <p>{{ visitor.mobile }}</p>

  <ng-container *ngIf="visitor.date_created">
    <h6>Date Visited</h6>
    <p>{{ (visitor.date_created * 1000) | timezoneConvertLong}}</p>
  </ng-container>
</mat-dialog-content>
